import { useAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

import { userLoadingAtom, useSetUserAtom, useUserAtom } from '../atoms/user-atom';
import { fetchUser } from '../fetch-user';

export function useUser() {
  const userAtom = useUserAtom();
  const setUserAtom = useSetUserAtom();
  const [userLoading, setUserLoading] = useAtom(userLoadingAtom);

  useEffect(() => {
    if (!userAtom) {
      const fetchData = async () => {
        setUserLoading(true);
        const user = await fetchUser();
        setUserLoading(false);
        setUserAtom(user);
      };
      fetchData();
    }
  }, [setUserAtom, setUserLoading, userAtom]);

  const refetch = useCallback(async () => {
    setUserLoading(true);
    const user = await fetchUser();
    setUserLoading(false);
    setUserAtom(user);
  }, [setUserAtom, setUserLoading]);

  return {
    user: userAtom,
    refetch,
    isLoading: userLoading,
  };
}
